import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Alert } from 'rsuite';
import { PrecoPsicologicoService } from '../services/PrecoPsicologicoService';
import type { DeleteFaixaRequest, FaixaDePrecoRequest, SimularPrecoRequest } from '../@types/IPA/PrecoPsicologico';

const QUERY_KEY = ['preco-psicologico', 'faixas'] as const;

export function useListarFaixas() {
  return useQuery(QUERY_KEY, () => PrecoPsicologicoService.listarFaixas());
}

export function useListarHistorico() {
  return useQuery(['preco-psicologico', 'historico'], () =>
    PrecoPsicologicoService.listarHistorico()
  );
}

export function useCriarFaixa() {
  const queryClient = useQueryClient();
  return useMutation(
    (data: FaixaDePrecoRequest) => PrecoPsicologicoService.criarFaixa(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY);
        Alert.success('Faixa criada com sucesso!', 5000);
      },
    }
  );
}

export function useEditarFaixa() {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, data }: { id: string; data: FaixaDePrecoRequest }) =>
      PrecoPsicologicoService.editarFaixa(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY);
        Alert.success('Faixa atualizada com sucesso!', 5000);
      },
    }
  );
}

export function useExcluirFaixa() {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, data }: { id: string; data: DeleteFaixaRequest }) =>
      PrecoPsicologicoService.excluirFaixa(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY);
        Alert.success('Faixa excluída com sucesso!', 5000);
      },
      onError: () => {
        Alert.error('Erro ao excluir faixa. Tente novamente.', 5000);
      },
    }
  );
}

export function useSimularPreco() {
  return useMutation((data: SimularPrecoRequest) =>
    PrecoPsicologicoService.simularPreco(data)
  );
}
